 
import React from "react";
import { StandadCard } from "../../../../../components/Cards";


import { TabPanel } from "../../../../../components/Tabs/TabPanel";
import { PageLoader } from "../../../../../components/PageLoader/PageLoader";
import { LoadState } from "../../../../../constants/enums";
import { useCustomerPolicyDetails, useQueryParms,
} from "../../../../../hooks";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ExistingPropertyCasualty } from "./LifeInsuranceAdditionalInformation/ExistingPropertyCasuality/ExistingPropertyCasuality";

export const LifeInsuranceAdditionalInformationRoot: React.FC = () => {
  const data = useOutletContext() as any;
  const customerId = data[0];
  const customerPolicyId = data[1];
const { getParm } = useQueryParms();
  const tabValue = getParm("tab");
  const selectedTab = tabValue ? Number(tabValue) : 0;

  const { details } = useCustomerPolicyDetails(
    customerPolicyId ? Number(customerPolicyId) : undefined
  );
  const navigate = useNavigate();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    navigate(
      `/life-insurance-policy/${customerId}/additional-information-tab/${customerPolicyId}?tab=${newValue}`
    );
  };


  return (
    <PageLoader
      loading={details.loading === LoadState.InProgress}
      error={details.error ? { message: details.error } : null}
    >
      <StandadCard>
        <TabPanel value={selectedTab} index={0}>
          <ExistingPropertyCasualty
            // customerId={customerId}
            customerpolicyId={customerPolicyId}
          />
        </TabPanel>
      </StandadCard>
    </PageLoader>
  );
};
